const Dashboard = (api: any) => ({
  getStats: () => api.get('/api/v1/dashboard/stats', {}, {}),
});

export default Dashboard;
